
const backgroundColors = {
    1: 'black',
    2: 'green',
    3: 'yellow',
    4: 'light',
    5: 'white',
    6: 'pink'
};
const getBackgroundColor = id => `background-${backgroundColors[id]}` || 'background-white';

export default getBackgroundColor;
